<script>
  // Skeleton rows, shown while a list is being fetched.
  //
  // Was `Loading<i class="fas fa-spinner fa-spin">` at text-4xl, centred. A
  // skeleton in the shape of the thing that is coming reads as "nearly there"
  // rather than "something is wrong", and it stops the page jumping when the
  // real rows land.
  export let rows = 3;
</script>

<div class="mt-6 flex flex-col gap-3" aria-busy="true" aria-label="Loading">
  {#each Array(rows) as _, i (i)}
    <div class="surface rail p-4 pl-5">
      <div class="flex items-start justify-between gap-4">
        <div class="w-full space-y-2">
          <div class="skeleton h-4 w-20 rounded-badge"></div>
          <div class="skeleton h-5 w-2/5"></div>
          <div class="skeleton h-3 w-3/5"></div>
        </div>
        <div class="flex shrink-0 gap-1.5">
          <div class="skeleton h-8 w-8 rounded-full"></div>
          <div class="skeleton h-8 w-8 rounded-full"></div>
        </div>
      </div>
    </div>
  {/each}
</div>
